import React from 'react'

export function DrawerBody({
  children,
}: {
  readonly children: React.ReactNode
}) {
  return <div className={'text-body mb-12'}>{children}</div>
}
